import axios from "axios";
import UseSecurity from "security/useSecurity";
import SnackbarUtils from "utils/SnackbarUtils";
const API_URL = window._env_.API_URL;
const API_PYTHON = window._env_.API_PYTHON;
//const API_URL = 'https://apitest-facturar-pa.emagic.fin.ec';
//const API_PYTHON = 'https://emagic-products.azure-api.net/factClientFunct';
// const API_URL_AUTH = 'http://localhost:9002';
//const API_URL_CORE = 'http://localhost:9004';
// const API_URL_REPO = 'http://localhost:9003';
// const API_URL_PAY = 'http://localhost:9005';
//const API_URL = 'https://api.facturar.com.pa';

let sesionCerrada = false;

function attachSessionInterceptor(instance) {
  instance.interceptors.response.use(
    (response) => {
      if (response.config?.url?.includes("/login")) sesionCerrada = false;
      return response;
    },
    (error) => {
      const isLoginRequest = (error.config?.url || "").includes("/login");

      if (!isLoginRequest && error.response?.status === 401 && !sesionCerrada) {
        sesionCerrada = true;
        const { signout } = UseSecurity();
        signout();
        SnackbarUtils.toast("Su sesión ha finalizado. Por favor, inicie sesión nuevamente.", "error");
      }
      return Promise.reject(error);
    }
  );
}

//api public
export const clientPublic = axios.create({
  baseURL: `${API_URL}/auth`,
});
attachSessionInterceptor(clientPublic);

// <<<<<<<<<<<<< core >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceBackendCore = axios.create({
  baseURL: `${API_URL}/web_core`,
});

instanceBackendCore.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceBackendCore);

export const httpCore = instanceBackendCore;

// <<<<<<<<<<<<< repo >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceBackendRepo = axios.create({
  baseURL: `${API_URL}/repo`,
});

instanceBackendRepo.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceBackendRepo);

export const httpRepo = instanceBackendRepo;

// <<<<<<<<<<<<< auth >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceBackend = axios.create({
  baseURL: `${API_URL}/auth`,
});

instanceBackend.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceBackend);

export default instanceBackend;

// <<<<<<<<<<<<< API PYTHON PARA CARGA MASIVA CLIENTES >>>>>>>>>>>>>>>>>>>>>>>>>>
let pythonBackend = axios.create({
  baseURL: `${API_PYTHON}/v1`,
});

pythonBackend.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(pythonBackend);

export const clientPythonBackend = pythonBackend;

// <<<<<<<<<<<<< Pagos >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceBackendPay = axios.create({
  baseURL: `${API_URL}/pay`,
});

instanceBackendPay.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceBackendPay);

export const clientPay = instanceBackendPay;

// <<<<<<<<<<<<< Notificador >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceBackendNotifier = axios.create({
  baseURL: `${API_URL}/notifier`,
});

instanceBackendNotifier.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceBackendNotifier);

export const clientNotifier = instanceBackendNotifier;

// <<<<<<<<<<<<< PDF >>>>>>>>>>>>>>>>>>>>>>>>>>
let instancePDF = axios.create({
  baseURL: `${API_URL}/web_core`,
  responseType: "blob",
});

instancePDF.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instancePDF);

export const clientBackendPDF = instancePDF;

// <<<<<<<<<<<<< XML >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceXML = axios.create({
  baseURL: `${API_URL}/web_core`,
  contentType: "application/xml; charset=utf-8",
});

instanceXML.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceXML);

export const clientBackendXML = instanceXML;

// <<<<<<<<<<<<< ZIP >>>>>>>>>>>>>>>>>>>>>>>>>>
let instanceZIP = axios.create({
  baseURL: `${API_URL}/web_core`,
  responseType: "arraybuffer",
});

instanceZIP.interceptors.request.use(
  async (config) => {
    const { getTk } = UseSecurity();
    config.headers.Authorization = await getTk();
    return config;
  },
  (error) => Promise.reject(error)
);
attachSessionInterceptor(instanceZIP);

export const clientBackendZIP = instanceZIP;